import { Box, Flex } from '@chakra-ui/react';
import React from 'react';

import config from 'configs/app';
import HeroBanner from 'ui/home/HeroBanner';
import LatestArbitrumL2Batches from 'ui/home/latestBatches/LatestArbitrumL2Batches';
import LatestZkEvmL2Batches from 'ui/home/latestBatches/LatestZkEvmL2Batches';
import LatestBlocks from 'ui/home/LatestBlocks';
import Stats from 'ui/home/Stats';
import Transactions from 'ui/home/Transactions';

const rollupFeature = config.features.rollup;

const Home = () => {
  const leftWidget = (() => {
    if (rollupFeature.isEnabled && !rollupFeature.homepage.showLatestBlocks) {
      switch (rollupFeature.type) {
        case 'zkEvm':
          return <LatestZkEvmL2Batches/>;
        case 'arbitrum':
          return <LatestArbitrumL2Batches/>;
      }
    }

    return <LatestBlocks/>;
  })();

  return (
    <Box as="main" w="100%" minW={ 0 }>
      <Flex direction="column" gap="0" w="100%" minW={ 0 }>
        <Box
          w={{ base: 'calc(100% + 24px)', lg: 'calc(100% + 48px)' }}
          ml={{ base: '-12px', lg: '-24px' }}
          mr={{ base: '-12px', lg: '-24px' }}
        >
          <HeroBanner/>
        </Box>
        <Box
          mt={{ base: '16px', lg: '-48px' }}
          position="relative"
          zIndex={ 1 }
        >
          <Flex direction="column" gap="16px">
            <Stats/>
            <Flex direction={{ base: 'column', xl: 'row' }} columnGap="16px" rowGap="16px" alignItems="stretch">
              { leftWidget }
              <Box flexGrow={ 1 } minW={ 0 }>
                <Transactions/>
              </Box>
            </Flex>
          </Flex>
        </Box>
      </Flex>
    </Box>
  );
};

export default Home;
